import { cva } from 'class-variance-authority';

// 1. Overlay: Fixed, full screen — opacity handled via inline styles
export const sheetBackdropClasses = cva('fixed inset-0 z-[var(--z-backdrop)] flex', {
  variants: {
    hideBackdrop: {
      true: '',
      false: 'bg-black/40'
    }
  }
});

export const sheetContentClasses = cva(
  ['z-[var(--z-modal)] flex max-h-screen flex-col bg-white shadow-xl'],
  {
    variants: {
      side: {
        right: 'ml-auto h-full w-96 min-w-72',
        left: 'mr-auto h-full w-96 min-w-72',
        bottom: 'fixed top-1/4 left-1/2 mx-auto h-[50vh] w-full max-w-md rounded-3xl'
      }
    },
    defaultVariants: {
      side: 'right'
    }
  }
);

export const sheetHeaderClasses = cva([
  'border-charcoal-alpha-50 flex flex-none flex-row items-start justify-between gap-1 border-1 border-b-1 border-solid py-4 ps-5 pe-3'
]);

export const sheetContentWrapperStyles = cva(['flex-1 overflow-y-auto p-4']);

export const sheetFooterClasses = cva(['border-charcoal-alpha-50 flex flex-none flex-col p-4']);
